module.exports = __webpack_public_path__ + "static/refinancePerson.228e03d1.png";